import { 
    CONTRACT_ADDITIONAL_AGREEMENT_STATE_GET_REQUEST, CONTRACT_ADDITIONAL_AGREEMENT_STATE_GET_SUCCESS, CONTRACT_ADDITIONAL_AGREEMENT_STATE_GET_ERROR, 
    CONTRACT_ADDITIONAL_AGREEMENT_STATE_GET_BY_KEY_REQUEST, CONTRACT_ADDITIONAL_AGREEMENT_STATE_GET_BY_KEY_SUCCESS, CONTRACT_ADDITIONAL_AGREEMENT_STATE_GET_BY_KEY_ERROR, 
    CONTRACT_ADDITIONAL_AGREEMENT_STATE_ADD_REQUEST, CONTRACT_ADDITIONAL_AGREEMENT_STATE_ADD_SUCCESS, CONTRACT_ADDITIONAL_AGREEMENT_STATE_ADD_ERROR, 
    CONTRACT_ADDITIONAL_AGREEMENT_STATE_EDIT_REQUEST, CONTRACT_ADDITIONAL_AGREEMENT_STATE_EDIT_SUCCESS, CONTRACT_ADDITIONAL_AGREEMENT_STATE_EDIT_ERROR, 
    CONTRACT_ADDITIONAL_AGREEMENT_STATE_DELETE_REQUEST, CONTRACT_ADDITIONAL_AGREEMENT_STATE_DELETE_SUCCESS, CONTRACT_ADDITIONAL_AGREEMENT_STATE_DELETE_ERROR
} from "../constants/contractAdditionalAgreementStateConstants";

const initialState = {
    contractAdditionalAgreementStates: [],
    contractAdditionalAgreementState: {},
    loading: false,
    success: null,
    error: null,
    contractAdditionalAgreementStateRequestedCount: 0,
};

export const contractAdditionalAgreementStateReducer = (state = initialState, action) => {
    switch (action.type)     {
        case CONTRACT_ADDITIONAL_AGREEMENT_STATE_GET_REQUEST:
            return {
                ...state,
                contractAdditionalAgreementStateRequestedCount: ++state.contractAdditionalAgreementStateRequestedCount,
                loading: true,
            };
        case CONTRACT_ADDITIONAL_AGREEMENT_STATE_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                contractAdditionalAgreementStates: action.payload,
                success: true,
            };
        case CONTRACT_ADDITIONAL_AGREEMENT_STATE_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case CONTRACT_ADDITIONAL_AGREEMENT_STATE_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CONTRACT_ADDITIONAL_AGREEMENT_STATE_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                contractAdditionalAgreementState: action.payload,
                success: true,
            };
        case CONTRACT_ADDITIONAL_AGREEMENT_STATE_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case CONTRACT_ADDITIONAL_AGREEMENT_STATE_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CONTRACT_ADDITIONAL_AGREEMENT_STATE_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case CONTRACT_ADDITIONAL_AGREEMENT_STATE_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case CONTRACT_ADDITIONAL_AGREEMENT_STATE_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CONTRACT_ADDITIONAL_AGREEMENT_STATE_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case CONTRACT_ADDITIONAL_AGREEMENT_STATE_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case CONTRACT_ADDITIONAL_AGREEMENT_STATE_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CONTRACT_ADDITIONAL_AGREEMENT_STATE_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case CONTRACT_ADDITIONAL_AGREEMENT_STATE_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
